
/// <amd-module name="Environments/EnvironmentsCommon/MessagesStore" />
import * as React from "react";
import { StoreBase } from "Environments/Flux/Store";
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { MessagesActions, IMessagePayload } from "Environments/EnvironmentsCommon/MessagesActions";

export class MessagesStore extends StoreBase {

    public static getKey(): string {
        return "environments-message-store";
    }

    public initialize(instanceId?: string): void {
        super.initialize(instanceId);

        this._state = {};
        this._actions = ActionsHubManager.GetActionsHub<MessagesActions>(MessagesActions, instanceId);
        this._actions.addMessage.addListener(this._addMessage);
        this._actions.clearMessage.addListener(this._clearMessage);
    }

    public disposeInternal(): void {
        this._actions.addMessage.removeListener(this._addMessage);
        this._actions.clearMessage.removeListener(this._clearMessage);
    }

    private _addMessage = (payload: IMessagePayload): void => {
        this._state[payload.key] = payload.value;
        this.emitChanged();
    }

    private _clearMessage = (key: string): void => {
        if(this._state[key]) {
            delete this._state[key] ;
        }
        this.emitChanged();
    }

    public getMessage(key: string): React.ReactNode {
        return this._state[key];
    }

    public getMessages(): { [key: string]: React.ReactNode } {
        return this._state;
    }

    private _state: { [key: string]: React.ReactNode };
    private _actions: MessagesActions;
}
